module.exports = __webpack_public_path__ + "static/img/redfile2.be312e67.png";